/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ServicesInputs */

const en_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

const lv_nav_services = /** @type {(inputs: Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakalpojumi`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {Nav_ServicesInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_services = /** @type {((inputs?: Nav_ServicesInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ServicesInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_services(inputs)
	return en_nav_services(inputs)
});